module.exports = __webpack_public_path__ + "catalog/items/firesafety/exit-down/exit-down.svg";